import Vue from 'vue'

const card = {
    namespaced: true,
    state: {
        cards: {},
        maxCards: 2
    },
    mutations: {
        showCard( state, card ) {
            const data = {...card}
            data.show = true
            Vue.set(state.cards , card.place , data )
            if( card.place > state.maxCards ) {
                for( let i=1;i<= (card.place-state.maxCards); i++ ) {
                    let card = state.cards[i]
                    if( card == undefined ) {
                        card = {
                            name : '',
                        }
                    }
                    card.show = false
                    Vue.set(state.cards , i , card )
                }
            }
        },
        hideCard( state , id ) {
            const card = state.cards[id]
            if( card != undefined )
                card.show = false
        },
        reset(state) {
            state.cards = {}
            for( let i=1;i<=state.maxCards;i++) {
                Vue.set( state.cards , i , {
                    name:"",
                    show: true
                })
            }
        }
    },
    getters: {
        isCardVisible: (state) => (id) => { 
            const card = state.cards[id]
            if( card == undefined )
                return false          
            return card.show
        },
        cardName: (state) => (id) => {
            return state.cards[id]?.name
        },
        cardData: (state) => (id) => {
            return state.cards[id]?.data
        }
    }, 
    actions: {
        
    }
}

export default card